import { render, staticRenderFns } from "./BankoPspRequestModal.vue?vue&type=template&id=c6b16ef6&scoped=true"
import script from "./BankoPspRequestModal.vue?vue&type=script&lang=js"
export * from "./BankoPspRequestModal.vue?vue&type=script&lang=js"
import style0 from "./BankoPspRequestModal.vue?vue&type=style&index=0&id=c6b16ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b16ef6",
  null
  
)

export default component.exports